<template>
    <div class="users-style">
        
        <ul class="list-group mb-3 " v-if='errormsg'>           
            <li class="list-group-item list-group-item-danger" v-for='data in errormsg'>{{data[0]}}</li>
        </ul>
        {{successmsg}}  
        
            <b-form @submit.stop.prevent="onSubmit">
                
                                
                <b-form-group id="password-group" label="Password" label-for="password" >
                    <b-form-input id="password" name="password" type="password" v-model="fdata.password" v-validate="{ required: true, min: 8 }" :state="validateState('password')" aria-describedby="password-feedback" data-vv-as="Password"></b-form-input>
                    <b-form-invalid-feedback id="password-feedback">{{ veeErrors.first('password') }}</b-form-invalid-feedback>
                </b-form-group>

                <b-form-group id="password_confirmation-group" label="Confirm Password" label-for="password_confirmation" >
                    <b-form-input id="password_confirmation" name="password_confirmation" type="password" v-model="fdata.password_confirmation" v-validate="{ required: true, confirmed: fdata.password }" :state="validateState('password_confirmation')" aria-describedby="password_confirmation-feedback" data-vv-as="Confirm Password"></b-form-input>
                    <b-form-invalid-feedback id="password_confirmation-feedback">{{ veeErrors.first('password_confirmation') }}</b-form-invalid-feedback>
                </b-form-group>


                <b-button type="submit" variant="primary">Submit</b-button>
            </b-form>                

    </div>
</template>
 
<script>

    export default{
         
        
        data(){
            return {
                disableme : true,              
                successmsg:'',
                errormsg:[],
                fdata: {id:null,  },
            }
        },
        methods:{
            
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            
            
            editEmployeeUserData:function(x)
            {         
                
                axios.get(this.$api_url+'/employee/settings/data' , {
                    params: {
                        //id: x
                    }
                }).then(function(response){
                    //this.fdata = response.data;
                    
                    console.log(response.data);
                    
                }.bind(this));
                
            },
            onSubmit(e) 
            {
                if(!this.checkNet()) return false;
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }

                    e.preventDefault();  
                    let currentObj = this;
                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }                 

                    let formData = new FormData();
                    
                    for (let [key, value] of Object.entries(this.fdata)) 
                    {                    
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);                    
                        console.log(`${key}: ${value}`);
                    } 

                    //if(this.logoUploaded)
                    //    formData.append('form_pic', this.logoUrl);

                    axios.post(this.$api_url+'/employee/settings', formData, config)
                                .then(function (response) 
                                {
                                    this.$bvToast.toast("Saved", {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });
                                    

                                    //location.reload();
                                    //window.location.href = this.$api_url;

                                    
                                }.bind(this))
                                .catch(function (error) 
                                {
                                    currentObj.errormsg = error.response.data.errors;
                                });
                });
            }
            

        },
        created: function(){
            this.editEmployeeUserData();
        }
    }
</script>